import React from 'react'
import { useTranslation } from 'i18n'
import { SStyled, useSTheme } from 'styles/theme'

import SBox from 'components/opinionless/SBox'
import SText from 'components/opinionless/SText'
import { LBText } from 'containers/Apply/steps/ApplicationStepLBIntroduction'
import { StepWizardChildProps } from 'react-step-wizard'
import XBanner from 'v2/components/XBanner'
import FImage from 'components/BaseComponents/FImage'

import { ga4_useTitle } from 'utils/ga4'
import { input } from 'components/BaseComponents/constants'

import style from './style.module.scss'

import { WIZARD_STEPS_MAPPING } from 'containers/Apply/LongBeachWizard'
import { updatePercentageAndStep } from 'v2/components/XProgressBar/utils'

const LBTextHeader = SStyled(SText)`
    ${(p) => `
        @media screen and (max-width: ${p.theme.breakpoints[0]}) {
            font-size: 24px;
            line-height: 130%;
        }
    `}
`

export const Container = SStyled(SBox)`
    width: 100%;
    max-width: 600px;
`

interface Props {
    setCurrentStep?: (number) => void
    fontFamily: any
    onNextStep?: any
    onPrevious?: any
    updatePercentage: any
}

const ReviewApplicationComplete: React.FC<Props> = (props: Props & StepWizardChildProps) => {
    const theme = useSTheme()
    const { t } = useTranslation(window.LANG_NS)

    const fontFamily = props.fontFamily

    ga4_useTitle('Review Application Complete')

    const { percentage, wizardStep, childWizzardStep } = updatePercentageAndStep(
        WIZARD_STEPS_MAPPING.review,
        WIZARD_STEPS_MAPPING.review.applicationComplete,
        WIZARD_STEPS_MAPPING
    )
    props.updatePercentage(percentage, wizardStep, childWizzardStep)
    return (
        <Container>
            <SBox>
                <LBTextHeader
                    sx={{
                        textAlign: 'left',
                        fontSize: '32px',
                        color: theme.colors.secondaryColor,
                        lineHeight: '120%',
                        fontFamily: fontFamily.header,
                        marginBottom: '24px',
                    }}
                >
                    {t('long_beach_review_application_complete_header')}
                </LBTextHeader>
                <FImage
                    sx={{
                        margin: `${input.desktop.marginTop} auto 0`,
                        display: 'block',
                    }}
                    width={'150px'}
                    imageUrl={'/lbcongrats.svg'}
                    alt={'review application complete'}
                />
                <LBText
                    sx={{
                        textAlignLast: 'left',
                        whiteSpace: 'pre-line',
                        fontFamily: 'Raleway',
                        fontWeight: '800',
                        lineHeight: '140%',
                        color: '#202020',
                        fontSize: '16px',
                        marginBottom: '24px',
                    }}
                >
                    {t('long_beach_review_application_complete_subheader')}
                </LBText>
                <div className={style.household_applicant_review_application_complete_banner}>
                    <XBanner
                        title={t('long_beach_review_application_complete_banner_title')}
                        description={t('long_beach_review_application_complete_banner_description')}
                        isCloseButton={true}
                        isButton={false}
                        type="info"
                    />
                </div>
            </SBox>
        </Container>
    )
}

export default ReviewApplicationComplete
